var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageLike = function SvgMypageLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD267",
    d: "m12 7.886 2.818-2.818A4.49 4.49 0 0 1 18 3.75H6c1.243 0 2.368.504 3.182 1.318z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M21.182 11.432a4.5 4.5 0 0 0-6.364-6.364L12 7.886 9.182 5.068a4.5 4.5 0 0 0-6.364 6.364L12 20.25z"
  })));
};
export default SvgMypageLike;